Postlogin.CCISAssessment = (function (assessment) {
    assessment.Popup = {
        language: Postlogin.CCISAssessment.getLanguageSetting(),
    };
    const self = assessment.Popup;

    const $modal = $('#beep-9-modal');
    self.init = function () {
        //
    };

    self.hideModal = function () {
        // only hide if a modal is actually visible
        if ($modal.hasClass('activated')) {
            $modal.removeClass('activated smaller');
            $('#light-overlay')
                .stop()
                .animate(
                    {
                        opacity: 0,
                    },
                    500,
                    () => {
                        $('#light-overlay').remove();
                    },
                );
            $('#dark-overlay')
                .stop()
                .animate(
                    {
                        opacity: 0,
                    },
                    500,
                    () => {
                        $('#dark-overlay').remove();
                    },
                );
            $('#beep-9-modal .content-container').fadeOut(1000);
            $('#beep-9-modal #user-interaction-button').fadeOut(300);

            setTimeout(() => {
                $('#user-interaction-button').remove();
            }, 500);

            $('#beep-9-modal .activity-mark').fadeIn(1000);
            $modal.trigger('beep9:hidden');
        }
    };

    /*
     * Create and show a modal window
     */
    self.showModal = function (options) {
        // stop any playing sounds
        Postlogin.CCISAssessment.stopAllSounds(false);

        $modal.removeClass('smaller');
        $modal.find('.content-container').removeClass('correct incorrect').fadeOut(200);

        // this makes sure the small version of beep-9 is visible at the bottom
        $modal.addClass('enabled');

        // set a class (ex. 'correct', or 'incorrect' for different screen bg colors)
        // ... this same class will be un-set on hide of the modal.
        if (typeof options.class !== 'undefined') {
            $modal.find('.content-container').addClass(options.class);
        }

        // if no title set, hide the h2 (more room for content)
        if (typeof options.title === 'undefined') {
            $modal.find('header h2').hide();
        } else {
            $modal.find('header h2').show();
            $modal.find('header h2').html(options.title);
        }

        // set the modal body content
        $modal.find('.beep-9-modal-content > .wrapper > .content').html(options.body);

        if (options.overlay === 'light') {
            // add the light overlay behind the modal
            if (!$('#light-overlay').length) {
                $('body').append('<div id="light-overlay"></div>');
            }
            $('#light-overlay')
                .stop()
                .animate(
                    {
                        opacity: 1,
                    },
                    500,
                    () => {
                        // Animation complete.
                    },
                );
        } else {
            // add the dark overlay behind the modal
            if (!$('#dark-overlay').length) {
                $('body').append('<div id="dark-overlay"></div>');
            }

            $('#dark-overlay')
                .stop()
                .animate(
                    {
                        opacity: 1,
                    },
                    500,
                    () => {
                        // Animation complete.
                    },
                );
        }

        // if specified, set onShow and onHide events
        const onShow = typeof options.onShow === 'function' ? options.onShow : function () {};
        const onHide = typeof options.onHide === 'function' ? options.onHide : function () {};

        $modal.unbind('beep9:shown');
        $modal.unbind('beep9:hidden');
        const resultsButton = $(
            '#content-container, #header-navigation, #bottom-stuff, #clouds-background-container, #page-container, #results-button',
        );

        $modal.on('beep9:shown', function (e) {
            $modal.find('.btn-success:eq(0)').focus();
            resultsButton.addClass('blur');
            onShow.call(this, e);
        });
        $modal.on('beep9:hidden', function (e) {
            $modal.find('.btn-success:eq(0)').blur();
            Postlogin.CCISAssessment.stopAllSounds(false);
            onHide.call(this, e);

            // if we had set a class on creation, remove that class on hiding...
            if (typeof options.class !== 'undefined') {
                $modal.find('.content-container').removeClass(options.class);
            }
            resultsButton.removeClass('blur');
        });

        // add any necessary buttons to the footer
        const $footer = $modal.find('footer');

        // TODO: fix this wack JS
        $footer.html('');
        if (Object.prototype.toString.call(options.actions) === '[object Array]') {
            for (let i = 0, l = options.actions.length; i < l; i++) {
                // eslint-disable-next-line no-param-reassign
                options.actions[i].onClick = typeof options.actions[i].onClick === 'function' ? options.actions[i].onClick : function () {};
                $(
                    `<button type="button" class="btn ${options.actions[i].cssClass || ''}">${
                        options.actions[i].label || '{Label Missing!}'
                    }</button>`,
                )
                    .appendTo($footer)
                    .on('click', options.actions[i].onClick);
            }
        } else {
            $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').appendTo($footer);
        }

        if (options.smaller === true) {
            $modal.addClass('smaller');
        }

        // bring the beep-9 modal to the forefront
        $modal.addClass('activated');

        // hide the activity mark
        $modal.find('.activity-mark').stop().fadeOut(500);

        // bring in the actual content
        $modal.find('.content-container').stop().fadeIn(1000);

        $modal.trigger('beep9:shown');
    };

    return assessment;
}(Postlogin.CCISAssessment || {}));
